import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export const TEACHING_LANGUAGES = [
  "English",
  "Mandarin Chinese",
  "Cantonese",
  "Spanish",
  "Korean",
  "Japanese",
];

export function useCoachLanguages() {
  const [languages, setLanguages] = useState({});
  useEffect(() => {
    api
      .get("/coach-languages")
      .then((r) => setLanguages(r.data || {}))
      .catch(() => setLanguages({}));
  }, []);
  return languages;
}
